module.exports = "https://cdn.hellotech.com/client-assets/computers_tablet_9d31f4d1bcf1ade31ef39eb7c50a7c3c.webp";